import { createContext } from 'react'
import { APP_CONFIG, AWS_CONFIG } from './config'
import { PLATFORM_AWS, PLATFORM_AZURE } from './utils/platform'
import * as azureAuth from './services/azureAuth'

interface AuthContextType {
  auth: boolean
  setAuth: (auth: boolean) => void
}

export const AuthContext = createContext<AuthContextType>({
  auth: false,
  setAuth: () => {},
})

export async function redirectToLogin() {
  if (APP_CONFIG.Platform === PLATFORM_AWS) {
    window.location.href = `https://${AWS_CONFIG.CognitoDomain}/login?response_type=code&client_id=${AWS_CONFIG.ClientId}&redirect_uri=${AWS_CONFIG.LoginRedirectUri}`
  } else if (APP_CONFIG.Platform === PLATFORM_AZURE) {
    try {
      await azureAuth.login()
    } catch (error) {
      console.error('Azure login error:', error)
    }
  } else {
    window.location.href = '/login'
  }
}

export async function redirectToLogout() {
  if (APP_CONFIG.Platform === PLATFORM_AWS) {
    window.location.href = `https://${AWS_CONFIG.CognitoDomain}/logout?response_type=code&client_id=${AWS_CONFIG.ClientId}&redirect_uri=${AWS_CONFIG.LoginRedirectUri}`
  } else if (APP_CONFIG.Platform === PLATFORM_AZURE) {
    try {
      azureAuth.logout()
    } catch (error) {
      console.error('Azure logout error:', error)
    }
  } else {
    window.location.href = '/login'
  }
}
